export default {
    install (Vue, options) {
        
    }
}


// WEBPACK FOOTER //
// ./src/directives/RolePlugin.js